import { format, parse } from "date-fns";
import React from "react";
import { Modal, Spinner } from "react-bootstrap";
import Table from "react-bootstrap/Table";
import { useSelector, useDispatch } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import OrderDetailItems from "../../../Common/Components/OrderDetailItems";
import { TitleHeader } from "../../../Common/Components/TitleHeader";
import { transformOrderDetailItems } from "../../../Services/MainService";
import { fetchOrderDetails } from "../../Services/OrderService";

export const OrderView = ({
  title = "Order Details",
  subtitle = "Below are your order details.",
}) => {
  const [loading, setLoading] = React.useState(false);
  const params = useParams();
  const [details, setDetails] = React.useState(null);
  const [items, setItems] = React.useState([]);
  const [tax, setTax] = React.useState(0);
  const [total, setTotal] = React.useState(0);
  const [subtotal, setSubtotal] = React.useState(0);
  const [itemPrice, setItemPrice] = React.useState(0);
  const [voucher, setVoucher] = React.useState("");
  const [discount, setDiscount] = React.useState(0);
  const [referralDiscount, setReferralDiscount] = React.useState(0);
  const [delivery, setDelivery] = React.useState(0);
  //   const [deliveryType, setDeliveryType] = React.useState(null);
  // const [trackOrder, setTrackOrder] = React.useState(null);
  //   const [cLoading, setCLoading] = React.useState(false);
  const config = useSelector((x) => x.Config);
  const navigate = useNavigate();
  const [show, setShow] = React.useState(false);
  const [track, setTrack] = React.useState([]);
  const [trackLoading] = React.useState(false);
  //   const [cShow, setCShow] = React.useState(false);
  const location = useLocation();
  const [open, setOpen] = React.useState({});
  const [count, setCount] = React.useState(0);
  const [address, setAddress] = React.useState(null);
  const { state } = useLocation();
  const dispatch = useDispatch();
  
  React.useEffect(() => {
  if (state?.fromOrderPlacement) {
    dispatch({ type: "setCart", payload: [] });
    dispatch({ type: "setOrderType", payload: null });
    dispatch({ type: "setOrderTypeId", payload: null });
    dispatch({ type: "setBookingType", payload: null });
    dispatch({ type: "setService", payload: null });
    dispatch({ type: "setCategory", payload: null });
    dispatch({ type: "setDeliveryDate", payload: null });
    dispatch({ type: "setPickupDate", payload: null });
    dispatch({ type: "setCoupon", payload: null });
    dispatch({ type: "setAddresses", payload: null });
    dispatch({ type: "setNote", payload: null });
    dispatch({ type: "setSelfPick", payload: null });
  }
}, [state]);

  // React.useEffect(() => {
  //   setLoading(true);
  //   fetchDeliveryType(50, 1).then(
  //     (res) => {
  //       setLoading(false);
  //       setDeliveryType(
  //         res.find((x) => x.title?.trim()?.toLowerCase() === orderType)
  //       );
  //     },
  //     (er) => {
  //       console.warn(er, "delivery types failed");
  //     }
  //   );
  // }, []);

  React.useEffect(() => {
    console.clear();
    const orderId = params?.["id"];
    if (!orderId) {
      navigate(-1, { replace: true });
    } else {
      setLoading(true);
      fetchOrderDetails(orderId).then(
        (res) => {
          setLoading(false);
          const { count, open, record, items_price } =
            transformOrderDetailItems(res.data.details);
          setCount(count);
          setOpen(open);
          setItems(record);
          setItemPrice(items_price);
          setTotal(res.data.order_amount);
          setSubtotal(res.data.subtotal);
          setVoucher(res.data.coupon_code);
          setTax(res.data.tax_amount);
          setDiscount(res.data.discount_amount);
          setReferralDiscount(res.data.referral_discount_amount);
          setDelivery(res.data.delivery_charge);
          //   setDeliveryType(res.data.laundry_delivery_type);
          setDetails(res.data);

          setAddress({
            pickup_coordinates: {
              longitude: res.data.pickup_coordinates?.coordinates?.[0],
              latitude: res.data.pickup_coordinates?.coordinates?.[1],
            },
            destination_coordinates: {
              longitude: res.data.destination_coordinates?.coordinates?.[0],
              latitude: res.data.destination_coordinates?.coordinates?.[1],
            },
            pickup_address: {
              ...res.data.pickup_address,
            },
            destination_address: {
              ...res.data.destination_address,
            },
          });
          processTrack(res.data);
        },
        (er) => {
          console.warn(er, "error on order fetch");
        }
      );
    }
  }, [params, location]);

  //   const cOrder = () => {
  //     if (!cLoading) {
  //       setCLoading(true);
  //       cancelOrder(details.id).then(
  //         (res) => {
  //           toast.success("Order cancelled Successfully!");
  //           navigate(`/app/order-canceled?orderId=${details.id}`, {
  //             replace: true,
  //           });
  //         },
  //         (er) => {
  //           setCLoading(false);
  //           toast.error("Something went wrong while canceling order!");
  //         }
  //       );
  //     }
  //   };
  const convertDate = (dateString) => {
    // Parse the date string into a Date object
    const date = parse(dateString, "yyyy-MM-dd HH:mm:ss", new Date());
    // Convert the Date object to an ISO string
    return date;
  };
  const transformStatus = (date, status) => {
    if (date) {
      const t = convertDate(date);
      return {
        status,
        time: format(t, "p"),
        date: format(t, "p, eee, dd MMM yyyy"),
      };
    }
  };
  const processTrack = (d) => {
    if (d) {
      const temp = [];
      const pending = transformStatus(d.pending, "Pending");
      if (pending) temp.push(pending);
      const confirmed = transformStatus(d.confirmed, "Confirmed");
      if (confirmed) temp.push(confirmed);
      const out_for_pickup = transformStatus(
        d.out_for_pickup,
        "Out For Pickup"
      );
      if (out_for_pickup) temp.push(out_for_pickup);
      const picked_up = transformStatus(d.picked_up, "Picked Up");
      if (picked_up) temp.push(picked_up);
      const arrived = transformStatus(d.arrived, "Arrived");
      if (arrived) temp.push(arrived);
      const processing = transformStatus(d.processing, "Processing");
      if (processing) temp.push(processing);
      const ready_for_delivery = transformStatus(
        d.ready_for_delivery,
        "Ready For Delivery"
      );
      if (ready_for_delivery) temp.push(ready_for_delivery);
      const out_for_delivery = transformStatus(
        d.out_for_delivery,
        "Out For Delivery"
      );
      if (out_for_delivery) temp.push(out_for_delivery);
      const delivered = transformStatus(d.delivered, "Delivered");
      if (delivered) temp.push(delivered);
      const deferred_at = transformStatus(d.deferred_at, "Deferred");
      if (deferred_at) temp.push(deferred_at);
      const cancelled = transformStatus(d.cancelled, "Cancelled");
      if (cancelled) temp.push(cancelled);
      const failed = transformStatus(d.failed, "Failed");
      if (failed) temp.push(failed);
      setTrack(temp);
    }
  };

  let parsedNotes = [];

  // try {
  //   parsedNotes = details?.note ? JSON.parse(details.note) : [];
  // } catch {
  //   parsedNotes = [];
  // }

  // if (typeof details?.note === "string") {
  //   parsedNotes = details.note.split(",").map(note => ({ note: note.trim() }));
  // } else {
  //   // If it's already an array of notes, parse it normally
  //   try {
  //     parsedNotes = details?.note ? JSON.parse(details.note) : [];
  //   } catch {
  //     parsedNotes = [];
  //   }
  // }

//   try {
//   if (typeof details?.note === "string") {
//     parsedNotes = JSON.parse(details.note);  // Parse the stringified JSON
//   }
// } catch (error) {
//   parsedNotes = [];
// }
  try {
  if (!details?.note) {
    parsedNotes = [];
  } 
  else if (typeof details.note === "string") {
    // Check if it's stringified JSON
    if (details.note.trim().startsWith("[")) {
      parsedNotes = JSON.parse(details.note);
    } else {
      // Single plain string
      parsedNotes = [{ note: details.note }];
    }
  } 
  else if (Array.isArray(details.note)) {
    parsedNotes = details.note;
  }
} catch {
  parsedNotes = [];
}

const bundleDiscount = items.flatMap(service => service.items)
  .reduce((acc, item) => acc + (item.price * item.free_items), 0);

  const printReceipt = () => {
    const isPrepaid = ["up_front_cash_payment", "wallet_on_delivery"].includes(details?.payment_method);
    const prepaidLabel = details?.payment_method === "wallet_on_delivery" ? "Wallet" : "Cash / Card";
    const template = `
      <!DOCTYPE html>
      <html lang="en">
      <head>
        <meta charset="UTF-8">
        <meta name="viewport" content="width=device-width, initial-scale=1.0">
        <title>Receipt for Order ${details.id}</title>
      </head>
      <body style="font-family: Arial, sans-serif; font-size: 12px; margin: 0; padding: 0; width: 3in;">
        <div style="width: 100%; max-width: 3.5in; margin: 0 auto; text-align: left;">
          ${isPrepaid ? `<div style="position: relative; height: 32px;">
            <div style="position: absolute; top: 5px; right: 8px; transform: rotate(-15deg); border: 2px solid #000; border-radius: 4px; padding: 2px 8px; font-size: 18px; font-weight: 900; letter-spacing: 2px;">PAID</div>
          </div>` : ""}
          <div style="text-align: center; font-weight: bold; font-size: 28px; letter-spacing: -1.5px;">Jabchaho</div>
          <br>
          <div style="text-align: center; font-weight: bold; font-size: 14px">Order ID : ${
            details?.id
          }</div>
          <div style="text-align: center;">Name : ${
            details?.customer?.f_name
          } ${details?.customer?.l_name}</div>
          ${
            isPrepaid
              ? `<div style="text-align: center;margin-top: 5px;font-size: 12px;font-weight: 900;font-style: italic;">
                PRE-PAID (${prepaidLabel})
              </div>`
              : ""
          }
          <br>
          <div style="border-bottom: 1px solid #000; margin: 5px 0;"></div>
  
          ${items
            .map(
              (item) => `
            <div style="font-weight: bold;">${item.service}</div>
            ${item.items
              .map(
                (innerItem) => `
              <div style="display: flex; justify-content: space-between;">
                <span>${innerItem.name} (x${innerItem.quantity})</span>
                <span>Rs. ${innerItem.price.toLocaleString()}</span>
                <span>Rs. ${(
                  innerItem.price * innerItem.quantity
                ).toLocaleString()}</span>
              </div>
                ${innerItem.item_note ? `<div style="font-size: 8px; py-2px; margin-bottom: 1px; font-style: italic;">Note: ${innerItem.item_note}</div>` : ""}
                ${innerItem.is_bundle_active ? `<div style="font-size: 8px;  margin-bottom: 4px; font-style: italic;">* Bundle offer applied</div>` : ""}
            `
              )
              .join("")}
          `
            )
            .join("")}
  
          <div style="border-bottom: 1px solid #000; margin: 5px 0;"></div>
          <div style="display: flex; justify-content: space-between;">
            <span>Total No Of Items:</span>
            <span></span>
            <span>${count?.toLocaleString()}</span>
          </div>
          ${bundleDiscount > 0 ? `
          <div style="display: flex; justify-content: space-between;">
            <span>Bundle Discount:</span>
            <span></span>
            <span>-${bundleDiscount?.toLocaleString()}</span>
          </div>
          ` : ""}
          <div style="display: flex; justify-content: space-between;">
            <span>Items Total:</span>
            <span></span>
            <span>Rs. ${itemPrice?.toLocaleString()}</span>
          </div>
          ${
            ""
            //   <div style="display: flex; justify-content: space-between;">
            //   <span>Items Total (incl. Tax):</span>
            //   <span></span>
            //   <span>Rs. ${itemPrice?.toLocaleString()}</span>
            // </div>
          }
          <div style="border-bottom: 1px solid #000; margin: 5px 0;"></div>
          ${
            //   <div style="display: flex; justify-content: space-between;">
            //   <span>Items Total (Excl. Tax):</span>
            //   <span></span>
            //   <span>Rs. ${itemPriceNoTax?.toLocaleString()}</span>
            // </div>
            ""
          }
          ${
            referralDiscount
              ? `
              <div style="display: flex; justify-content: space-between;">
                <span>Referral Discount:</span>
                <span></span>
                <span>Rs. ${referralDiscount?.toLocaleString()}</span>
              </div>`
              : ""
          }
          ${
            discount
              ? `
              <div style="display: flex; justify-content: space-between;">
                <span>Coupon Discount:</span>
                <span></span>
                <span>-Rs. ${discount?.toLocaleString()}</span>
              </div>`
              : ""
          }
          <div style="display: flex; justify-content: space-between;">
            <span>SubTotal:</span>
            <span></span>
            <span>Rs. ${subtotal?.toLocaleString()}</span>
          </div>
          <div style="display: flex; justify-content: space-between;">
            <span>VAT/TAX:</span>
            <span></span>
            <span>Rs. ${tax.toLocaleString()}</span>
          </div>
          <div style="display: flex; justify-content: space-between;">
            <span>Delivery Fee:</span>
            <span></span>
            <span>Rs. ${parseFloat(delivery)?.toLocaleString()}</span>
          </div>
          <div style="display: flex; justify-content: space-between;">
            <span>Total:</span>
            <span></span>
            <span>Rs. ${total?.toLocaleString()}</span>
          </div>
          ${isPrepaid ? `
          <div style="display: flex; justify-content: space-between; font-weight: normal;">
            <span>Pre-paid (${prepaidLabel}):</span>
            <span>${prepaidLabel === "Wallet" ? "" : "Rs. "}${total?.toLocaleString()}</span>
          </div>
          <div style="border-bottom: 1px dashed #000; margin: 5px 0;"></div>
          <div style="display: flex; justify-content: space-between; ">
            <span>Total Paid:</span>
            <span>Rs. ${total?.toLocaleString()}</span>
          </div>
          <div style="display: flex; justify-content: space-between;">
            <span>Balance Due:</span>
            <span>Rs. 0</span>
          </div>` : ""}
          <div style="border-bottom: 1px solid #000; margin: 5px 0;"></div>
          <div style="margin-top: 5px; font-weight: 500">Collected On: ${format(
            Date.now(),
            "dd MMMM yyyy, p"
          )}</div>
          <div style="font-weight: 500">Delivery Date: ${format(
            details?.order_delivery_time_slot_date,
            "dd MMMM yyyy"
          )}</div>
          <div style="font-weight: 500">Delivery Time: ${
            details?.order_delivery_time_slot
          }</div>
          ${
      parsedNotes.length > 0
        ? `
      <br>  
      <div>
        <strong>Order Note:</strong>
        <ul style="margin:5px 0; padding-left:15px;">
          ${parsedNotes.map(n => `<li>${n.note}</li>`).join("")}
        </ul>
      </div>
    `
        : ""
      }
          <div style="border-bottom: 1px solid #000; margin: 5px 0;"></div>
          <div style="text-align: center; margin-top: 10px;">Download the Jabchaho Laundry App on Google Play & the iOS App Store for easy, hassle-free ordering.</div>
          <div style="border-bottom: 1px solid #000; margin: 5px 0;"></div>
          <div style="text-align: center; margin-top: 10px;"> <strong>Note:</strong> You are kindly requested to check the items within 7 days of delivery / receiving, with the attached bar code intact. Complaints received after this period will not be entertained.</div>
          <div style="text-align: center; margin-top: 10px;">Thank You</div>
          <div style="text-align: center; margin-top: 20px; font-weight: 500">Receipt Printed On:</div>
          <div style="text-align: center;">${format(
            details?.created_at,
            "eeee, dd MMMM yyyy"
          )} At ${format(details?.created_at, "p")}</div>
        </div>
      </body>
      </html>
    `;

    var win = window.open(
      "",
      "",
      "left=0,top=0,width=1000,height=1000,toolbar=0,scrollbars=0,status=0"
    );
    win?.document.write(template);
    win?.document.close();
    win?.focus();
    win?.print();
    win?.close();
  };

  
  return (
    <>
      <TitleHeader title={title} subtitle={subtitle} />
      <div className="container" style={{ minHeight: "80vh" }}>
        <div className="row justify-content-center py-4">
          <div className="col-xl-6 col-lg-7 col-md-10 col-12">
            {loading ? (
              <div className="text-center">
                <Spinner variant="primary" />
              </div>
            ) : details ? (
              <>
                <div className="card mb-3">
                  <div className="card-body">
                    <h5 className="fw-bold mb-1">{details?.id}</h5>
                    <h5 className="fw-normal" style={{ color: "#828282" }}>
                      {/* {format(details?.creation_date, "p, eee, dd MMM yyyy")} */}
                    </h5>
                    <hr style={{ borderStyle: "dashed", margin: "10px 0px" }} />
                    <div className="d-flex align-items-center">
                      <div className="col-7">
                        <h6 className="fw-bold mb-1">Order Type</h6>
                        <h6 className="fw-normal" style={{ color: "#828282" }}>
                          {details?.delivery_type?.id == "3"
                            ? "Come & Collect "
                            : details.delivery_type?.title}{" "}
                          {details?.delivery_type?.id == "3"
                            ? `(${
                                details?.booking_type == "1"
                                  ? "Regular"
                                  : "Express"
                              })`
                            : null}
                        </h6>
                      </div>
                      <div className="col-5">
                        <h6 className="fw-bold mb-1">Payment Method</h6>
                        <small
                          className={`history-order-card-delivery-type-badge ${
                            details?.payment_method === "card_on_delivery"
                              ? "blue"
                              : ""
                          }`}
                        >
                          {details?.payment_method === "cash_on_delivery"
                            ? "cod"
                            : details?.payment_method === "card_on_delivery"
                            ? "ccod"
                            : details?.payment_method ===
                              "up_front_cash_payment"
                            ? "prepaid"
                            : "Wallet"}
                        </small>
                      </div>
                    </div>
                  </div>
                </div>
                {/* Service based Item cards Card */}
                <OrderDetailItems items={items} setOpen={setOpen} open={open} />
                {/* Total/Subtotal */}
                <div className="card mb-3">
                  <div
                    className="card-header border-0"
                    style={{ backgroundColor: "#fff" }}
                  >
                    <Table borderless responsive className="mb-0">
                      <tbody>
                        <tr>
                          <td className="fw-semibold">Total Items</td>
                          <td className="fw-bold text-end">
                            {count?.toLocaleString()} item(s)
                          </td>
                        </tr>
                        <tr>
                          <td className="fw-semibold">Item Price</td>
                          <td className="fw-bold text-end">
                            Rs. {itemPrice?.toLocaleString()}
                          </td>
                        </tr>
                        {/* <tr>
                          <td className="fw-semibold">
                            Total Price (Incl. Tax)
                          </td>
                          <td className="fw-bold text-end">
                            Rs. {itemPrice?.toLocaleString()}
                          </td>
                        </tr> */}
                      </tbody>
                    </Table>
                  </div>
                  <hr className="mt-0" />
                  <div className="card-body pt-0">
                    <Table borderless responsive className="mb-0">
                      <tbody>
                        {/* <tr>
                          <td className="fw-semibold">
                            Total Price (Excl. Tax)
                          </td>
                          <td className="fw-bold text-end">
                            Rs. {itemPriceNoTax?.toLocaleString()}
                          </td>
                        </tr> */}
                        {referralDiscount > 0 && (
                          <tr style={{ backgroundColor: "#d0f0c0" }}>
                            <td className="fw-semibold">Referral Discount</td>
                            <td className="fw-bold text-end"> Rs. {Math.round(referralDiscount)?.toLocaleString()}</td>
                          </tr>
                        )}
                        {discount ? (
                          <>
                            <tr>
                              <td
                                className="fw-semibold"
                                style={{ backgroundColor: "#94e19459" }}
                              >
                                Discount
                              </td>
                              <td
                                className="fw-bold text-end"
                                style={{ backgroundColor: "#94e19459" }}
                              >
                                -Rs. {discount?.toLocaleString()}
                              </td>
                            </tr>
                            <tr>
                              <td className="fw-semibold">Voucher Used</td>
                              <td className="fw-bold text-end">{voucher}</td>
                            </tr>
                          </>
                        ) : null}
                        <tr>
                          <td className="fw-semibold">Subtotal</td>
                          <td className="fw-bold text-end">
                            Rs. {subtotal?.toLocaleString()}
                          </td>
                        </tr>
                        <tr>
                          <td className="fw-semibold">VAT / Tax</td>
                          <td className="fw-bold text-end">
                            Rs. {tax.toLocaleString()}
                          </td>
                        </tr>
                        <tr>
                          <td className="fw-semibold">Delivery Fee</td>
                          <td className="fw-bold text-end">
                            Rs. {parseFloat(delivery)?.toLocaleString()}
                          </td>
                        </tr>
                        <tr>
                          <td colSpan={2}>
                            <hr className="my-0" />
                          </td>
                        </tr>
                        <tr>
                          <td className="fw-semibold">Total</td>
                          <td className="fw-bold text-end">
                            Rs. {total?.toLocaleString()}
                          </td>
                        </tr>
                      </tbody>
                    </Table>
                  </div>
                </div>
                {/* Dates */}
                <div className="card mb-3">
                  <div className="card-body">
                    <h5 className="fw-bold">Scheduled Dates</h5>
                    <div className="app-dates-container border border-gray rounded mt-4">
                      <div className="col-12 col-md-5 px-4">
                        <small
                          style={{ position: "absolute", top: "-12px" }}
                          className="bg-white px-2"
                        >
                          Pickup
                        </small>
                        <div className="d-flex align-items-center py-3 border-r border-gray">
                          <i
                            className="fa-regular fa-calendar-plus me-3"
                            style={{ fontSize: "22px", color: "#666" }}
                          ></i>
                          {format(
                            parse(
                              details?.order_pickup_time_slot_date,
                              "yyyy-MM-dd",
                              Date.now()
                            ),
                            "iii, dd MMM"
                          )}
                          <br />
                          {details?.order_pickup_time_slot}
                        </div>
                      </div>
                      {details?.order_delivery_time_slot_date ? (
                        <>
                          <div className="col-1 d-none d-md-block border-start border-gray h-100 py-2 border-2">
                            &nbsp;
                          </div>
                          <hr className="w-100 my-1 d-block d-md-none" />
                          <div className="col-12 col-md-5 px-4">
                            <small
                              style={{ position: "absolute" }}
                              className="bg-white px-2 app-dates-delivery-label"
                            >
                              Delivery
                            </small>
                            <div className="d-flex align-items-center py-3">
                              <i
                                className="fa-regular fa-calendar-plus me-3"
                                style={{ fontSize: "22px", color: "#666" }}
                              ></i>
                              {format(
                                parse(
                                  details?.order_delivery_time_slot_date,
                                  "yyyy-MM-dd",
                                  Date.now()
                                ),
                                "iii, dd MMM"
                              )}
                              <br />
                              {details?.order_delivery_time_slot || "---"}
                            </div>
                          </div>
                        </>
                      ) : null}
                    </div>
                  </div>
                </div>
                {/* Addresses */}
                <div className="card mb-3">
                  <div className="card-body">
                    <span className="fw-semibold mb-3 d-block">Address</span>
                    <div className="row">
                      <div className="col-1 text-end pe-0">
                        <i
                          className="fa-solid fa-circle-dot"
                          style={{ color: "#32b6e9" }}
                        ></i>
                      </div>
                      <div className="col-11">
                        <h6 className="mb-1">Pickup Address</h6>
                        <p className="m-0">
                          {address?.pickup_address
                            ? `${address?.pickup_address?.addressLine1}, ${address?.pickup_address?.addressLine2}, ${address?.pickup_address?.area}, ${address?.pickup_address?.area_phase}`
                            : "Select address"}
                        </p>
                        <hr style={{ borderStyle: "doted" }} />
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-1 text-end pe-0">
                        <i
                          className="fa-solid fa-location-dot text-primary"
                          style={{ fontSize: "20px" }}
                        ></i>
                      </div>
                      <div className="col-11">
                        <h6 className="mb-1">Delivery Address</h6>
                        <p className="m-0">
                          {address?.destination_address
                            ? `${address?.destination_address?.addressLine1}, ${address?.destination_address?.addressLine2}, ${address?.destination_address?.area}, ${address?.destination_address?.area_phase}`
                            : "Select address"}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                {/* Note */}
                {details.note ? (
                  <div className="card mb-3">
                    <div className="card-body">
                      <h5 className="fw-bold mb-3">Order Note.</h5>
                        {parsedNotes.length > 0 && (
                          <ul>
                            {parsedNotes.map((n, i) => (
                              <li key={n.id ?? i}>{n.note}</li>
                            ))}
                          </ul>
                        )}
                    </div>
                  </div>
                ) : null}
                {/* Rider */}
                {details?.rider ? (
                  <div className="card mb-3">
                    <div className="card-body">
                      <h5 className="fw-bold mb-3">Rider Details</h5>
                      <div className="d-flex justify-content-between align-items-center flex-wrap">
                        <div className="d-flex align-items-center flex-wrap">
                          <img
                            style={{ backgroundColor: "#eee" }}
                            src={`${config?.base_urls?.delivery_man_image_url}/${details?.rider.image}`}
                            alt=""
                            className="avatar p-1 me-2"
                          />
                          <h6 className="mb-0">{`${details.rider.f_name} ${details.rider.l_name}`}</h6>
                        </div>
                        <a href={`tel:${details.rider.phone}`}>
                          <i className="fa-solid fa-phone d-block"></i>
                        </a>
                      </div>
                    </div>
                  </div>
                ) : null}
              </>
            ) : null}
          </div>
        </div>
      </div>
      {details ? (
        <>
          <div className="container-fluid bg-white">
            <div
              className="row justify-content-center"
              style={{ padding: "20px 0px" }}
            >
              <div
                className="d-flex col-lg-6 col-md-7 col-12 justify-content-center flex-column flex-md-row"
                style={{ gap: "20px" }}
              >
                <div
                  className="text-center service-btn next"
                  onClick={() => {
                    setShow(true);
                  }}
                >
                  Track Order
                </div>
                <button
                  className="btn btn-dark text-primary"
                  onClick={() => {
                    printReceipt();
                  }}
                >
                  Print Receipt
                </button>

                {/* {details?.order_status === "pending" ? (
                  <div
                    className="text-center service-btn danger"
                    onClick={() => {
                      if (!cLoading) {
                        setCShow(true);
                      }
                    }}
                  >
                    {cLoading ? <Spinner size="sm" /> : null} Cancel Order
                  </div>
                ) : null} */}
              </div>
            </div>
          </div>
          <Modal
            show={show}
            centered
            onHide={() => {
              setShow(false);
            }}
            style={{ zIndex: 1056 }}
          >
            <Modal.Header closeButton className="py-2">
              <Modal.Title style={{ fontSize: "18px" }}>
                Order Status
              </Modal.Title>
            </Modal.Header>
            <Modal.Body className="d-flex flex-column align-items-center">
              {trackLoading ? (
                <div className="text-center">
                  <Spinner variant="primary" />
                </div>
              ) : track.length > 0 ? (
                <>
                  <div className="pe-4 w-100">
                    <ul className="app-timeline w-100">
                      {track.map((x, i) => (
                        <>
                          <li>
                            <div className="d-flex flex-wrap justify-content-between">
                              <span className="fw-semibold">{x.status}</span>
                              <span>{x.time}</span>
                            </div>
                            <span className="d-block mt-1">{x.date}</span>
                            {i !== track.length - 1 ? <hr /> : null}
                          </li>
                        </>
                      ))}
                    </ul>
                  </div>
                </>
              ) : (
                <h4 className="text-center text-uppercase text-muted">
                  No Records Found!
                </h4>
              )}
            </Modal.Body>
          </Modal>
        </>
      ) : null}
      {/* <ConfirmationModal
        show={cShow}
        text="Are you sure you want to cancel this order? "
        onNo={() => {
          setCShow(false);
        }}
        onYes={() => {
          setCShow(false);
          cOrder();
        }}
      /> */}
    </>
  );
};
